"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
function BottomTabs(props) {
    var _a, _b, _c, _d;
    const useStyles = styles_1.makeStyles({
        root: {
            justifyContent: 'space-around',
            background: ((_a = props.style) === null || _a === void 0 ? void 0 : _a.colorBackground) || 'white',
            borderTop: `3px solid ${((_b = props.style) === null || _b === void 0 ? void 0 : _b.colorBorderTop) || '#eeeeee'}`,
            minHeight: 100,
            '& .MuiBottomNavigationAction-root': {
                color: ((_c = props.style) === null || _c === void 0 ? void 0 : _c.color) || '#f4a993',
                fontSize: 37,
            },
            '& .MuiBottomNavigationAction-label': {
                marginTop: 8,
            },
            '& .Mui-selected': {
                color: ((_d = props.style) === null || _d === void 0 ? void 0 : _d.colorSelected) || '#fc6624',
            },
        },
    });
    const classes = useStyles();
    return (React.createElement(core_1.BottomNavigation, { classes: classes, value: props.currentTabValue, showLabels: true, onChange: props.onTabChanged, style: {
            position: 'fixed',
            bottom: 0,
            width: '100vw',
            left: 0,
            right: 0,
        } }, props.tabs.map((item) => {
        return (React.createElement(core_1.BottomNavigationAction, { key: item.value, label: item.label, value: item.value, icon: props.currentTabValue === item.value ? item.iconSelected || item.icon : item.icon }));
    })));
}
exports.default = BottomTabs;
//# sourceMappingURL=BottomTabs.js.map